<template>
  <div class="d-flex flex-column flex-md-row align-items-center p-3 px-md-4 mb-3 bg-white border-bottom shadow-sm">
    <h5 class="my-0 mr-md-auto font-weight-normal">
      <router-link to="/">Vue Mini Project</router-link>
    </h5>
    <nav class="my-2 my-md-0 mr-md-3">
      <router-link to="/user">User management</router-link>
      <router-link v-if="!loggedIn" to="/login">Login</router-link>
       <UserProfileDropdown/>
    </nav>
    <a class="btn btn-outline-primary" routerlink="cart">Administrator</a>
  </div>
  <router-view />
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
<script>
import UserProfileDropdown from './components/ProfileDropdown.vue'

export default {
  components: {
    UserProfileDropdown
  },
  // ... rest of your App.vue logic ...
  data() {
    return {
      loggedIn: false
    }
  },
  created () {
    this.checkLogin();
  },
  methods: {
    checkLogin() {
      const token = localStorage.getItem('token');
      this.loggedIn = !!token;
    }
  }
}
</script>
<style>
nav {
  display: flex;
  align-items: center;
  gap: 10px; /* khoảng cách giữa các mục */
}

.nav-link {
  margin-right: 10px;
  text-decoration: none;
  color: #333;
}

.dropdown {
  position: relative;
}

.dropdown-menu {
  min-width: 150px;
  background-color: white;
  border: 1px solid #ccc;
  padding: 0.5rem 0;
  z-index: 1000;
  position: absolute;
}

.dropdown-item {
  display: block;
  padding: 0.5rem 1rem;
  cursor: pointer;
  text-decoration: none;
  color: #333;
}

.dropdown-item:hover {
  background-color: #f0f0f0;
}
</style>
